import api from "./axios";

const systemRequest = {
  getAll: () => {
    return api.get("/system", { orgContext: "global" });
  },
  find: (id) => {
    return api.get(`/system/${id}`, { orgContext: "global" });
  },
  runtimePricing: () => {
    return api.get("/system/runtime/pricing", { orgContext: "tenant" });
  },
  save: (form) => {
    return api.post("/system", form, { orgContext: "global" });
  },
  update: (id, form) => {
    return api.patch(`/system/${id}`, form, { orgContext: "global" });
  },
  delete: (id) => {
    return api.delete(`/system/${id}`, { orgContext: "global" });
  },
};

export default systemRequest;
